/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { PaginatedDTO_PatientProviderDTO_ } from '../models/PaginatedDTO_PatientProviderDTO_'
import type { PatientProviderCreateDTO } from '../models/PatientProviderCreateDTO'
import type { PatientProviderDTO } from '../models/PatientProviderDTO'
import type { PatientProviderPatchDTO } from '../models/PatientProviderPatchDTO'
import type { CancelablePromise } from '../core/CancelablePromise'
import { OpenAPI } from '../core/OpenAPI'
import { request as __request } from '../core/request'
export class AspenPatientProvidersService {
    /**
     * Index
     * @returns PaginatedDTO_PatientProviderDTO_ Successful Response
     * @throws ApiError
     */
    public static indexPatientProvidersGet({
        page = 1,
        limit = 10,
        providerId,
        patientId,
        sort
    }: {
        /**
         * Page number for pagination, starting at 1
         */
        page?: number
        /**
         * Number of items per page, maximum 1000
         */
        limit?: number
        /**
         * Filter by provider_id
         */
        providerId?: string | null
        /**
         * Filter by patient_id
         */
        patientId?: string | null
        /**
         * Sort results by 'field[:asc|desc]'. Defaults to 'asc'. Example: 'name:desc', 'created_at'.
         */
        sort?: string | null
    }): CancelablePromise<PaginatedDTO_PatientProviderDTO_> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/aspen/patient-providers',
            query: {
                page: page,
                limit: limit,
                provider_id: providerId,
                patient_id: patientId,
                sort: sort
            },
            errors: {
                422: `Validation Error`
            }
        })
    }
    /**
     * Create
     * @returns PatientProviderDTO Successful Response
     * @throws ApiError
     */
    public static createPatientProvidersPost({ requestBody }: { requestBody: PatientProviderCreateDTO }): CancelablePromise<PatientProviderDTO> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/aspen/patient-providers',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`
            }
        })
    }
    /**
     * Get
     * @returns PatientProviderDTO Successful Response
     * @throws ApiError
     */
    public static getPatientProvidersPatientProviderIdGet({
        patientProviderId
    }: {
        patientProviderId: string
    }): CancelablePromise<PatientProviderDTO> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/aspen/patient-providers/{patient_provider_id}',
            path: {
                patient_provider_id: patientProviderId
            },
            errors: {
                422: `Validation Error`
            }
        })
    }
    /**
     * Patch
     * @returns PatientProviderDTO Successful Response
     * @throws ApiError
     */
    public static patchPatientProvidersPatientProviderIdPatch({
        patientProviderId,
        requestBody
    }: {
        patientProviderId: string
        requestBody: PatientProviderPatchDTO
    }): CancelablePromise<PatientProviderDTO> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/aspen/patient-providers/{patient_provider_id}',
            path: {
                patient_provider_id: patientProviderId
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`
            }
        })
    }
    /**
     * Delete
     * Delete a patient-provider association.
     * Automatically logs deletion to the audit trail.
     * @returns string Successful Response
     * @throws ApiError
     */
    public static deletePatientProvidersPatientProviderIdDelete({
        patientProviderId
    }: {
        patientProviderId: string
    }): CancelablePromise<Record<string, string>> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/aspen/patient-providers/{patient_provider_id}',
            path: {
                patient_provider_id: patientProviderId
            },
            errors: {
                422: `Validation Error`
            }
        })
    }
}
